/**
 * 自动生成， 请不要手工修改！
 */


export enum AnnouncementStatus {
    IN_REVIEW,
    DUE_TO_PAY,
    ACTIVE,
    CANCELLED,
    OBSOLETE,
    HIDDEN,
    DISLIKED
}
